export class KeepCurrentScroll {
    constructor() {
        let that = this;
        document.addEventListener("DOMContentLoaded", function(event){
            window.setTimeout(() => {
                that.init();
            }, 0)
        });
    }
    init() {
        if(localStorage.scrollPosition && JSON.parse(localStorage.scrollPosition).currentPage == window.location.href.split('?')[0]) {
            window.scrollBy(0, JSON.parse(localStorage.getItem('scrollPosition')).currentScroll);
        }
        const currentObject = {
            currentScroll: window.scrollY,
            currentPage: window.location.href.split('?')[0]
        }
        localStorage.setItem("scrollPosition", JSON.stringify(currentObject));
        document.addEventListener('scroll', function(e) {
            const currentObject = {
                currentScroll: window.scrollY,
                currentPage: window.location.href.split('?')[0]
            }
            localStorage.setItem("scrollPosition", JSON.stringify(currentObject));
        });

    }
}
